/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var shared_pb = require('./shared_pb.js');
goog.exportSymbol('proto.fleet.AlternateSchedule', null, global);
goog.exportSymbol('proto.fleet.AlternateScheduleOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.AlternateScheduleResponse', null, global);
goog.exportSymbol('proto.fleet.GetLastTimeSlotOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.LastTimeSlotResponse', null, global);
goog.exportSymbol('proto.fleet.MaterializedSchedule', null, global);
goog.exportSymbol('proto.fleet.MaterializedScheduleOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.MaterializedScheduleResponse', null, global);
goog.exportSymbol('proto.fleet.OperatingAreaDetails', null, global);
goog.exportSymbol('proto.fleet.OperatingAreaScheduleRequest', null, global);
goog.exportSymbol('proto.fleet.OperatingAreasAbbrevRequest', null, global);
goog.exportSymbol('proto.fleet.OperatingAreasOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.OperatingAreasRequest', null, global);
goog.exportSymbol('proto.fleet.OperatingAreasResponse', null, global);
goog.exportSymbol('proto.fleet.RegularScheduleOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.RegularScheduleResponse', null, global);
goog.exportSymbol('proto.fleet.RemoveRequest', null, global);
goog.exportSymbol('proto.fleet.ScheduleBlock', null, global);
goog.exportSymbol('proto.fleet.ScheduleType', null, global);
goog.exportSymbol('proto.fleet.SetAlternateScheduleRequest', null, global);
goog.exportSymbol('proto.fleet.SetRegularScheduleRequest', null, global);
goog.exportSymbol('proto.fleet.SiteWeatherForecast', null, global);
goog.exportSymbol('proto.fleet.SiteWeatherMap', null, global);
goog.exportSymbol('proto.fleet.TimeSlot', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreaScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.OperatingAreaScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreaScheduleRequest.displayName = 'proto.fleet.OperatingAreaScheduleRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreaScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreaScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreaScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreaScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    range: (f = msg.getRange()) && shared_pb.LocalDateRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreaScheduleRequest}
 */
proto.fleet.OperatingAreaScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreaScheduleRequest;
  return proto.fleet.OperatingAreaScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreaScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreaScheduleRequest}
 */
proto.fleet.OperatingAreaScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = new shared_pb.LocalDateRange;
      reader.readMessage(value,shared_pb.LocalDateRange.deserializeBinaryFromReader);
      msg.setRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreaScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreaScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreaScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreaScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.LocalDateRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.OperatingAreaScheduleRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.OperatingAreaScheduleRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional LocalDateRange range = 2;
 * @return {?proto.fleet.LocalDateRange}
 */
proto.fleet.OperatingAreaScheduleRequest.prototype.getRange = function() {
  return /** @type{?proto.fleet.LocalDateRange} */ (
    jspb.Message.getWrapperField(this, shared_pb.LocalDateRange, 2));
};


/** @param {?proto.fleet.LocalDateRange|undefined} value */
proto.fleet.OperatingAreaScheduleRequest.prototype.setRange = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.OperatingAreaScheduleRequest.prototype.clearRange = function() {
  this.setRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.OperatingAreaScheduleRequest.prototype.hasRange = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SetRegularScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.SetRegularScheduleRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.SetRegularScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SetRegularScheduleRequest.displayName = 'proto.fleet.SetRegularScheduleRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.SetRegularScheduleRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SetRegularScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SetRegularScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SetRegularScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetRegularScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dayOfWeekList: jspb.Message.getRepeatedField(msg, 2),
    scheduleBlocksList: jspb.Message.toObjectList(msg.getScheduleBlocksList(),
    proto.fleet.ScheduleBlock.toObject, includeInstance),
    startDate: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SetRegularScheduleRequest}
 */
proto.fleet.SetRegularScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SetRegularScheduleRequest;
  return proto.fleet.SetRegularScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SetRegularScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SetRegularScheduleRequest}
 */
proto.fleet.SetRegularScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setDayOfWeekList(value);
      break;
    case 3:
      var value = new proto.fleet.ScheduleBlock;
      reader.readMessage(value,proto.fleet.ScheduleBlock.deserializeBinaryFromReader);
      msg.addScheduleBlocks(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SetRegularScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SetRegularScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SetRegularScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetRegularScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDayOfWeekList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getScheduleBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fleet.ScheduleBlock.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.SetRegularScheduleRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.SetRegularScheduleRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 day_of_week = 2;
 * @return {!Array<number>}
 */
proto.fleet.SetRegularScheduleRequest.prototype.getDayOfWeekList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<number>} value */
proto.fleet.SetRegularScheduleRequest.prototype.setDayOfWeekList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.SetRegularScheduleRequest.prototype.addDayOfWeek = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.fleet.SetRegularScheduleRequest.prototype.clearDayOfWeekList = function() {
  this.setDayOfWeekList([]);
};


/**
 * repeated ScheduleBlock schedule_blocks = 3;
 * @return {!Array<!proto.fleet.ScheduleBlock>}
 */
proto.fleet.SetRegularScheduleRequest.prototype.getScheduleBlocksList = function() {
  return /** @type{!Array<!proto.fleet.ScheduleBlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.ScheduleBlock, 3));
};


/** @param {!Array<!proto.fleet.ScheduleBlock>} value */
proto.fleet.SetRegularScheduleRequest.prototype.setScheduleBlocksList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fleet.ScheduleBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.SetRegularScheduleRequest.prototype.addScheduleBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fleet.ScheduleBlock, opt_index);
};


proto.fleet.SetRegularScheduleRequest.prototype.clearScheduleBlocksList = function() {
  this.setScheduleBlocksList([]);
};


/**
 * optional string start_date = 4;
 * @return {string}
 */
proto.fleet.SetRegularScheduleRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.SetRegularScheduleRequest.prototype.setStartDate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SetAlternateScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.SetAlternateScheduleRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.SetAlternateScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SetAlternateScheduleRequest.displayName = 'proto.fleet.SetAlternateScheduleRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.SetAlternateScheduleRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SetAlternateScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SetAlternateScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAlternateScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    scheduleBlocksList: jspb.Message.toObjectList(msg.getScheduleBlocksList(),
    proto.fleet.ScheduleBlock.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SetAlternateScheduleRequest}
 */
proto.fleet.SetAlternateScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SetAlternateScheduleRequest;
  return proto.fleet.SetAlternateScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SetAlternateScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SetAlternateScheduleRequest}
 */
proto.fleet.SetAlternateScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = new proto.fleet.ScheduleBlock;
      reader.readMessage(value,proto.fleet.ScheduleBlock.deserializeBinaryFromReader);
      msg.addScheduleBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SetAlternateScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SetAlternateScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAlternateScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScheduleBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fleet.ScheduleBlock.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.SetAlternateScheduleRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.SetAlternateScheduleRequest.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ScheduleBlock schedule_blocks = 3;
 * @return {!Array<!proto.fleet.ScheduleBlock>}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.getScheduleBlocksList = function() {
  return /** @type{!Array<!proto.fleet.ScheduleBlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.ScheduleBlock, 3));
};


/** @param {!Array<!proto.fleet.ScheduleBlock>} value */
proto.fleet.SetAlternateScheduleRequest.prototype.setScheduleBlocksList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fleet.ScheduleBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.SetAlternateScheduleRequest.prototype.addScheduleBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fleet.ScheduleBlock, opt_index);
};


proto.fleet.SetAlternateScheduleRequest.prototype.clearScheduleBlocksList = function() {
  this.setScheduleBlocksList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.RemoveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.RemoveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.RemoveRequest.displayName = 'proto.fleet.RemoveRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.RemoveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.RemoveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.RemoveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RemoveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.RemoveRequest}
 */
proto.fleet.RemoveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.RemoveRequest;
  return proto.fleet.RemoveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.RemoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.RemoveRequest}
 */
proto.fleet.RemoveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.RemoveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.RemoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.RemoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RemoveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.RemoveRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.RemoveRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.fleet.RemoveRequest.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.RemoveRequest.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.OperatingAreasRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.OperatingAreasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreasRequest.displayName = 'proto.fleet.OperatingAreasRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.OperatingAreasRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaIdsList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreasRequest}
 */
proto.fleet.OperatingAreasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreasRequest;
  return proto.fleet.OperatingAreasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreasRequest}
 */
proto.fleet.OperatingAreasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOperatingAreaIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 operating_area_ids = 1;
 * @return {!Array<number>}
 */
proto.fleet.OperatingAreasRequest.prototype.getOperatingAreaIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.fleet.OperatingAreasRequest.prototype.setOperatingAreaIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.OperatingAreasRequest.prototype.addOperatingAreaIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.OperatingAreasRequest.prototype.clearOperatingAreaIdsList = function() {
  this.setOperatingAreaIdsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreasAbbrevRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.OperatingAreasAbbrevRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.OperatingAreasAbbrevRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreasAbbrevRequest.displayName = 'proto.fleet.OperatingAreasAbbrevRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.OperatingAreasAbbrevRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreasAbbrevRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreasAbbrevRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreasAbbrevRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasAbbrevRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    abbrevIdsList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreasAbbrevRequest}
 */
proto.fleet.OperatingAreasAbbrevRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreasAbbrevRequest;
  return proto.fleet.OperatingAreasAbbrevRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreasAbbrevRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreasAbbrevRequest}
 */
proto.fleet.OperatingAreasAbbrevRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAbbrevIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreasAbbrevRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreasAbbrevRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreasAbbrevRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasAbbrevRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbbrevIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string abbrev_ids = 1;
 * @return {!Array<string>}
 */
proto.fleet.OperatingAreasAbbrevRequest.prototype.getAbbrevIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.fleet.OperatingAreasAbbrevRequest.prototype.setAbbrevIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.OperatingAreasAbbrevRequest.prototype.addAbbrevIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.OperatingAreasAbbrevRequest.prototype.clearAbbrevIdsList = function() {
  this.setAbbrevIdsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.MaterializedSchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.MaterializedSchedule.repeatedFields_, null);
};
goog.inherits(proto.fleet.MaterializedSchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.MaterializedSchedule.displayName = 'proto.fleet.MaterializedSchedule';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.MaterializedSchedule.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.MaterializedSchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.MaterializedSchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.MaterializedSchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedSchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
    scheduleBlocksList: jspb.Message.toObjectList(msg.getScheduleBlocksList(),
    proto.fleet.ScheduleBlock.toObject, includeInstance),
    scheduleType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    date: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.MaterializedSchedule}
 */
proto.fleet.MaterializedSchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.MaterializedSchedule;
  return proto.fleet.MaterializedSchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.MaterializedSchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.MaterializedSchedule}
 */
proto.fleet.MaterializedSchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.ScheduleBlock;
      reader.readMessage(value,proto.fleet.ScheduleBlock.deserializeBinaryFromReader);
      msg.addScheduleBlocks(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScheduleType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.MaterializedSchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.MaterializedSchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.MaterializedSchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedSchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScheduleBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.ScheduleBlock.serializeBinaryToWriter
    );
  }
  f = message.getScheduleType();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated ScheduleBlock schedule_blocks = 1;
 * @return {!Array<!proto.fleet.ScheduleBlock>}
 */
proto.fleet.MaterializedSchedule.prototype.getScheduleBlocksList = function() {
  return /** @type{!Array<!proto.fleet.ScheduleBlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.ScheduleBlock, 1));
};


/** @param {!Array<!proto.fleet.ScheduleBlock>} value */
proto.fleet.MaterializedSchedule.prototype.setScheduleBlocksList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.ScheduleBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.MaterializedSchedule.prototype.addScheduleBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.ScheduleBlock, opt_index);
};


proto.fleet.MaterializedSchedule.prototype.clearScheduleBlocksList = function() {
  this.setScheduleBlocksList([]);
};


/**
 * optional int32 schedule_type = 2;
 * @return {number}
 */
proto.fleet.MaterializedSchedule.prototype.getScheduleType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.MaterializedSchedule.prototype.setScheduleType = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string date = 3;
 * @return {string}
 */
proto.fleet.MaterializedSchedule.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.MaterializedSchedule.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.MaterializedScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.MaterializedScheduleResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.MaterializedScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.MaterializedScheduleResponse.displayName = 'proto.fleet.MaterializedScheduleResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.MaterializedScheduleResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.MaterializedScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.MaterializedScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.MaterializedScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedulesList: jspb.Message.toObjectList(msg.getSchedulesList(),
    proto.fleet.MaterializedSchedule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.MaterializedScheduleResponse}
 */
proto.fleet.MaterializedScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.MaterializedScheduleResponse;
  return proto.fleet.MaterializedScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.MaterializedScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.MaterializedScheduleResponse}
 */
proto.fleet.MaterializedScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.MaterializedSchedule;
      reader.readMessage(value,proto.fleet.MaterializedSchedule.deserializeBinaryFromReader);
      msg.addSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.MaterializedScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.MaterializedScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.MaterializedScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.MaterializedSchedule.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MaterializedSchedule schedules = 1;
 * @return {!Array<!proto.fleet.MaterializedSchedule>}
 */
proto.fleet.MaterializedScheduleResponse.prototype.getSchedulesList = function() {
  return /** @type{!Array<!proto.fleet.MaterializedSchedule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.MaterializedSchedule, 1));
};


/** @param {!Array<!proto.fleet.MaterializedSchedule>} value */
proto.fleet.MaterializedScheduleResponse.prototype.setSchedulesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.MaterializedSchedule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.MaterializedSchedule}
 */
proto.fleet.MaterializedScheduleResponse.prototype.addSchedules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.MaterializedSchedule, opt_index);
};


proto.fleet.MaterializedScheduleResponse.prototype.clearSchedulesList = function() {
  this.setSchedulesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.RegularScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.RegularScheduleResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.RegularScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.RegularScheduleResponse.displayName = 'proto.fleet.RegularScheduleResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.RegularScheduleResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.RegularScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.RegularScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.RegularScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RegularScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysOfWeekList: jspb.Message.getRepeatedField(msg, 1),
    scheduleBlocksList: jspb.Message.toObjectList(msg.getScheduleBlocksList(),
    proto.fleet.ScheduleBlock.toObject, includeInstance),
    startDate: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.RegularScheduleResponse}
 */
proto.fleet.RegularScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.RegularScheduleResponse;
  return proto.fleet.RegularScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.RegularScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.RegularScheduleResponse}
 */
proto.fleet.RegularScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setDaysOfWeekList(value);
      break;
    case 2:
      var value = new proto.fleet.ScheduleBlock;
      reader.readMessage(value,proto.fleet.ScheduleBlock.deserializeBinaryFromReader);
      msg.addScheduleBlocks(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.RegularScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.RegularScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.RegularScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RegularScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysOfWeekList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getScheduleBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fleet.ScheduleBlock.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated int32 days_of_week = 1;
 * @return {!Array<number>}
 */
proto.fleet.RegularScheduleResponse.prototype.getDaysOfWeekList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.fleet.RegularScheduleResponse.prototype.setDaysOfWeekList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.RegularScheduleResponse.prototype.addDaysOfWeek = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.RegularScheduleResponse.prototype.clearDaysOfWeekList = function() {
  this.setDaysOfWeekList([]);
};


/**
 * repeated ScheduleBlock schedule_blocks = 2;
 * @return {!Array<!proto.fleet.ScheduleBlock>}
 */
proto.fleet.RegularScheduleResponse.prototype.getScheduleBlocksList = function() {
  return /** @type{!Array<!proto.fleet.ScheduleBlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.ScheduleBlock, 2));
};


/** @param {!Array<!proto.fleet.ScheduleBlock>} value */
proto.fleet.RegularScheduleResponse.prototype.setScheduleBlocksList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fleet.ScheduleBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.RegularScheduleResponse.prototype.addScheduleBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet.ScheduleBlock, opt_index);
};


proto.fleet.RegularScheduleResponse.prototype.clearScheduleBlocksList = function() {
  this.setScheduleBlocksList([]);
};


/**
 * optional string start_date = 3;
 * @return {string}
 */
proto.fleet.RegularScheduleResponse.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.RegularScheduleResponse.prototype.setStartDate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AlternateScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AlternateScheduleResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.AlternateScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AlternateScheduleResponse.displayName = 'proto.fleet.AlternateScheduleResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AlternateScheduleResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AlternateScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AlternateScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AlternateScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    alternateSchedulesList: jspb.Message.toObjectList(msg.getAlternateSchedulesList(),
    proto.fleet.AlternateSchedule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AlternateScheduleResponse}
 */
proto.fleet.AlternateScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AlternateScheduleResponse;
  return proto.fleet.AlternateScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AlternateScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AlternateScheduleResponse}
 */
proto.fleet.AlternateScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.AlternateSchedule;
      reader.readMessage(value,proto.fleet.AlternateSchedule.deserializeBinaryFromReader);
      msg.addAlternateSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AlternateScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AlternateScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AlternateScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlternateSchedulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.AlternateSchedule.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AlternateSchedule alternate_schedules = 1;
 * @return {!Array<!proto.fleet.AlternateSchedule>}
 */
proto.fleet.AlternateScheduleResponse.prototype.getAlternateSchedulesList = function() {
  return /** @type{!Array<!proto.fleet.AlternateSchedule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.AlternateSchedule, 1));
};


/** @param {!Array<!proto.fleet.AlternateSchedule>} value */
proto.fleet.AlternateScheduleResponse.prototype.setAlternateSchedulesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.AlternateSchedule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.AlternateSchedule}
 */
proto.fleet.AlternateScheduleResponse.prototype.addAlternateSchedules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.AlternateSchedule, opt_index);
};


proto.fleet.AlternateScheduleResponse.prototype.clearAlternateSchedulesList = function() {
  this.setAlternateSchedulesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.OperatingAreasResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.OperatingAreasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreasResponse.displayName = 'proto.fleet.OperatingAreasResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.OperatingAreasResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreasList: jspb.Message.toObjectList(msg.getOperatingAreasList(),
    proto.fleet.OperatingAreaDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreasResponse}
 */
proto.fleet.OperatingAreasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreasResponse;
  return proto.fleet.OperatingAreasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreasResponse}
 */
proto.fleet.OperatingAreasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.OperatingAreaDetails;
      reader.readMessage(value,proto.fleet.OperatingAreaDetails.deserializeBinaryFromReader);
      msg.addOperatingAreas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.OperatingAreaDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OperatingAreaDetails operating_areas = 1;
 * @return {!Array<!proto.fleet.OperatingAreaDetails>}
 */
proto.fleet.OperatingAreasResponse.prototype.getOperatingAreasList = function() {
  return /** @type{!Array<!proto.fleet.OperatingAreaDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.OperatingAreaDetails, 1));
};


/** @param {!Array<!proto.fleet.OperatingAreaDetails>} value */
proto.fleet.OperatingAreasResponse.prototype.setOperatingAreasList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.OperatingAreaDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.OperatingAreaDetails}
 */
proto.fleet.OperatingAreasResponse.prototype.addOperatingAreas = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.OperatingAreaDetails, opt_index);
};


proto.fleet.OperatingAreasResponse.prototype.clearOperatingAreasList = function() {
  this.setOperatingAreasList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.LastTimeSlotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.LastTimeSlotResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.LastTimeSlotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.LastTimeSlotResponse.displayName = 'proto.fleet.LastTimeSlotResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.LastTimeSlotResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.LastTimeSlotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.LastTimeSlotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.LastTimeSlotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LastTimeSlotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysList: jspb.Message.toObjectList(msg.getDaysList(),
    proto.fleet.TimeSlot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.LastTimeSlotResponse}
 */
proto.fleet.LastTimeSlotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.LastTimeSlotResponse;
  return proto.fleet.LastTimeSlotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.LastTimeSlotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.LastTimeSlotResponse}
 */
proto.fleet.LastTimeSlotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.TimeSlot;
      reader.readMessage(value,proto.fleet.TimeSlot.deserializeBinaryFromReader);
      msg.addDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.LastTimeSlotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.LastTimeSlotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.LastTimeSlotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LastTimeSlotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.TimeSlot.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeSlot days = 1;
 * @return {!Array<!proto.fleet.TimeSlot>}
 */
proto.fleet.LastTimeSlotResponse.prototype.getDaysList = function() {
  return /** @type{!Array<!proto.fleet.TimeSlot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.TimeSlot, 1));
};


/** @param {!Array<!proto.fleet.TimeSlot>} value */
proto.fleet.LastTimeSlotResponse.prototype.setDaysList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.TimeSlot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.TimeSlot}
 */
proto.fleet.LastTimeSlotResponse.prototype.addDays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.TimeSlot, opt_index);
};


proto.fleet.LastTimeSlotResponse.prototype.clearDaysList = function() {
  this.setDaysList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ScheduleBlock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ScheduleBlock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ScheduleBlock.displayName = 'proto.fleet.ScheduleBlock';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ScheduleBlock.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ScheduleBlock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ScheduleBlock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ScheduleBlock.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, ""),
    seatCap: jspb.Message.getFieldWithDefault(msg, 2, 0),
    leadTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    start: jspb.Message.getFieldWithDefault(msg, 4, ""),
    end: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.ScheduleBlock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ScheduleBlock;
  return proto.fleet.ScheduleBlock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ScheduleBlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.ScheduleBlock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterval(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeatCap(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ScheduleBlock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ScheduleBlock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ScheduleBlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ScheduleBlock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeatCap();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLeadTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string interval = 1;
 * @return {string}
 */
proto.fleet.ScheduleBlock.prototype.getInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.ScheduleBlock.prototype.setInterval = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 seat_cap = 2;
 * @return {number}
 */
proto.fleet.ScheduleBlock.prototype.getSeatCap = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.ScheduleBlock.prototype.setSeatCap = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string lead_time = 3;
 * @return {string}
 */
proto.fleet.ScheduleBlock.prototype.getLeadTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.ScheduleBlock.prototype.setLeadTime = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string start = 4;
 * @return {string}
 */
proto.fleet.ScheduleBlock.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.ScheduleBlock.prototype.setStart = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string end = 5;
 * @return {string}
 */
proto.fleet.ScheduleBlock.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.fleet.ScheduleBlock.prototype.setEnd = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AlternateSchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AlternateSchedule.repeatedFields_, null);
};
goog.inherits(proto.fleet.AlternateSchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AlternateSchedule.displayName = 'proto.fleet.AlternateSchedule';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AlternateSchedule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AlternateSchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AlternateSchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AlternateSchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateSchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scheduleBlocksList: jspb.Message.toObjectList(msg.getScheduleBlocksList(),
    proto.fleet.ScheduleBlock.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AlternateSchedule}
 */
proto.fleet.AlternateSchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AlternateSchedule;
  return proto.fleet.AlternateSchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AlternateSchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AlternateSchedule}
 */
proto.fleet.AlternateSchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.fleet.ScheduleBlock;
      reader.readMessage(value,proto.fleet.ScheduleBlock.deserializeBinaryFromReader);
      msg.addScheduleBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AlternateSchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AlternateSchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AlternateSchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateSchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScheduleBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fleet.ScheduleBlock.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.fleet.AlternateSchedule.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.AlternateSchedule.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ScheduleBlock schedule_blocks = 2;
 * @return {!Array<!proto.fleet.ScheduleBlock>}
 */
proto.fleet.AlternateSchedule.prototype.getScheduleBlocksList = function() {
  return /** @type{!Array<!proto.fleet.ScheduleBlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.ScheduleBlock, 2));
};


/** @param {!Array<!proto.fleet.ScheduleBlock>} value */
proto.fleet.AlternateSchedule.prototype.setScheduleBlocksList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fleet.ScheduleBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.ScheduleBlock}
 */
proto.fleet.AlternateSchedule.prototype.addScheduleBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet.ScheduleBlock, opt_index);
};


proto.fleet.AlternateSchedule.prototype.clearScheduleBlocksList = function() {
  this.setScheduleBlocksList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreasOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.OperatingAreasOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.OperatingAreasOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreasOrErrorResponse.displayName = 'proto.fleet.OperatingAreasOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.OperatingAreasOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.OperatingAreasOrErrorResponse.OperatingAreasOneOfCase = {
  OPERATING_AREAS_ONE_OF_NOT_SET: 0,
  OPERATING_AREAS: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.OperatingAreasOrErrorResponse.OperatingAreasOneOfCase}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.getOperatingAreasOneOfCase = function() {
  return /** @type {proto.fleet.OperatingAreasOrErrorResponse.OperatingAreasOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.OperatingAreasOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreasOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreasOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreas: (f = msg.getOperatingAreas()) && proto.fleet.OperatingAreasResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreasOrErrorResponse}
 */
proto.fleet.OperatingAreasOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreasOrErrorResponse;
  return proto.fleet.OperatingAreasOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreasOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreasOrErrorResponse}
 */
proto.fleet.OperatingAreasOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.OperatingAreasResponse;
      reader.readMessage(value,proto.fleet.OperatingAreasResponse.deserializeBinaryFromReader);
      msg.setOperatingAreas(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreasOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreasOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreasOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreas();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.OperatingAreasResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional OperatingAreasResponse operating_areas = 1;
 * @return {?proto.fleet.OperatingAreasResponse}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.getOperatingAreas = function() {
  return /** @type{?proto.fleet.OperatingAreasResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.OperatingAreasResponse, 1));
};


/** @param {?proto.fleet.OperatingAreasResponse|undefined} value */
proto.fleet.OperatingAreasOrErrorResponse.prototype.setOperatingAreas = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.OperatingAreasOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.OperatingAreasOrErrorResponse.prototype.clearOperatingAreas = function() {
  this.setOperatingAreas(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.hasOperatingAreas = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.OperatingAreasOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.OperatingAreasOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.OperatingAreasOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.OperatingAreasOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AlternateScheduleOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.AlternateScheduleOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.AlternateScheduleOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AlternateScheduleOrErrorResponse.displayName = 'proto.fleet.AlternateScheduleOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.AlternateScheduleOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.AlternateScheduleOrErrorResponse.AlternateScheduleOneOfCase = {
  ALTERNATE_SCHEDULE_ONE_OF_NOT_SET: 0,
  ALTERNATE_SCHEDULE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.AlternateScheduleOrErrorResponse.AlternateScheduleOneOfCase}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.getAlternateScheduleOneOfCase = function() {
  return /** @type {proto.fleet.AlternateScheduleOrErrorResponse.AlternateScheduleOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.AlternateScheduleOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AlternateScheduleOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AlternateScheduleOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateScheduleOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    alternateSchedule: (f = msg.getAlternateSchedule()) && proto.fleet.AlternateScheduleResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AlternateScheduleOrErrorResponse}
 */
proto.fleet.AlternateScheduleOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AlternateScheduleOrErrorResponse;
  return proto.fleet.AlternateScheduleOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AlternateScheduleOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AlternateScheduleOrErrorResponse}
 */
proto.fleet.AlternateScheduleOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.AlternateScheduleResponse;
      reader.readMessage(value,proto.fleet.AlternateScheduleResponse.deserializeBinaryFromReader);
      msg.setAlternateSchedule(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AlternateScheduleOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AlternateScheduleOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AlternateScheduleOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlternateSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.AlternateScheduleResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional AlternateScheduleResponse alternate_schedule = 1;
 * @return {?proto.fleet.AlternateScheduleResponse}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.getAlternateSchedule = function() {
  return /** @type{?proto.fleet.AlternateScheduleResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.AlternateScheduleResponse, 1));
};


/** @param {?proto.fleet.AlternateScheduleResponse|undefined} value */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.setAlternateSchedule = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.AlternateScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.AlternateScheduleOrErrorResponse.prototype.clearAlternateSchedule = function() {
  this.setAlternateSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.hasAlternateSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.AlternateScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.AlternateScheduleOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.AlternateScheduleOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.RegularScheduleOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.RegularScheduleOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.RegularScheduleOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.RegularScheduleOrErrorResponse.displayName = 'proto.fleet.RegularScheduleOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.RegularScheduleOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.RegularScheduleOrErrorResponse.RegularScheduleOneOfCase = {
  REGULAR_SCHEDULE_ONE_OF_NOT_SET: 0,
  REGULAR_SCHEDULE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.RegularScheduleOrErrorResponse.RegularScheduleOneOfCase}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.getRegularScheduleOneOfCase = function() {
  return /** @type {proto.fleet.RegularScheduleOrErrorResponse.RegularScheduleOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.RegularScheduleOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.RegularScheduleOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.RegularScheduleOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RegularScheduleOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    regularSchedule: (f = msg.getRegularSchedule()) && proto.fleet.RegularScheduleResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.RegularScheduleOrErrorResponse}
 */
proto.fleet.RegularScheduleOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.RegularScheduleOrErrorResponse;
  return proto.fleet.RegularScheduleOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.RegularScheduleOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.RegularScheduleOrErrorResponse}
 */
proto.fleet.RegularScheduleOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.RegularScheduleResponse;
      reader.readMessage(value,proto.fleet.RegularScheduleResponse.deserializeBinaryFromReader);
      msg.setRegularSchedule(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.RegularScheduleOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.RegularScheduleOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RegularScheduleOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegularSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.RegularScheduleResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegularScheduleResponse regular_schedule = 1;
 * @return {?proto.fleet.RegularScheduleResponse}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.getRegularSchedule = function() {
  return /** @type{?proto.fleet.RegularScheduleResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.RegularScheduleResponse, 1));
};


/** @param {?proto.fleet.RegularScheduleResponse|undefined} value */
proto.fleet.RegularScheduleOrErrorResponse.prototype.setRegularSchedule = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.RegularScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.RegularScheduleOrErrorResponse.prototype.clearRegularSchedule = function() {
  this.setRegularSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.hasRegularSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.RegularScheduleOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.RegularScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.RegularScheduleOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.RegularScheduleOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.MaterializedScheduleOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.MaterializedScheduleOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.MaterializedScheduleOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.MaterializedScheduleOrErrorResponse.displayName = 'proto.fleet.MaterializedScheduleOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.MaterializedScheduleOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.MaterializedScheduleOneOfCase = {
  MATERIALIZED_SCHEDULE_ONE_OF_NOT_SET: 0,
  MATERIALIZED_SCHEDULE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.MaterializedScheduleOrErrorResponse.MaterializedScheduleOneOfCase}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.getMaterializedScheduleOneOfCase = function() {
  return /** @type {proto.fleet.MaterializedScheduleOrErrorResponse.MaterializedScheduleOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.MaterializedScheduleOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.MaterializedScheduleOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.MaterializedScheduleOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedScheduleOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    materializedSchedule: (f = msg.getMaterializedSchedule()) && proto.fleet.MaterializedScheduleResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.MaterializedScheduleOrErrorResponse}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.MaterializedScheduleOrErrorResponse;
  return proto.fleet.MaterializedScheduleOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.MaterializedScheduleOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.MaterializedScheduleOrErrorResponse}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.MaterializedScheduleResponse;
      reader.readMessage(value,proto.fleet.MaterializedScheduleResponse.deserializeBinaryFromReader);
      msg.setMaterializedSchedule(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.MaterializedScheduleOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.MaterializedScheduleOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.MaterializedScheduleOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaterializedSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.MaterializedScheduleResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional MaterializedScheduleResponse materialized_schedule = 1;
 * @return {?proto.fleet.MaterializedScheduleResponse}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.getMaterializedSchedule = function() {
  return /** @type{?proto.fleet.MaterializedScheduleResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.MaterializedScheduleResponse, 1));
};


/** @param {?proto.fleet.MaterializedScheduleResponse|undefined} value */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.setMaterializedSchedule = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.MaterializedScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.MaterializedScheduleOrErrorResponse.prototype.clearMaterializedSchedule = function() {
  this.setMaterializedSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.hasMaterializedSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.MaterializedScheduleOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.MaterializedScheduleOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.MaterializedScheduleOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetLastTimeSlotOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.GetLastTimeSlotOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.GetLastTimeSlotOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetLastTimeSlotOrErrorResponse.displayName = 'proto.fleet.GetLastTimeSlotOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.LastTimeSlotOneOfCase = {
  LAST_TIME_SLOT_ONE_OF_NOT_SET: 0,
  LAST_TIME_SLOT: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.GetLastTimeSlotOrErrorResponse.LastTimeSlotOneOfCase}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.getLastTimeSlotOneOfCase = function() {
  return /** @type {proto.fleet.GetLastTimeSlotOrErrorResponse.LastTimeSlotOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.GetLastTimeSlotOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetLastTimeSlotOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetLastTimeSlotOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lastTimeSlot: (f = msg.getLastTimeSlot()) && proto.fleet.LastTimeSlotResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetLastTimeSlotOrErrorResponse}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetLastTimeSlotOrErrorResponse;
  return proto.fleet.GetLastTimeSlotOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetLastTimeSlotOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetLastTimeSlotOrErrorResponse}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.LastTimeSlotResponse;
      reader.readMessage(value,proto.fleet.LastTimeSlotResponse.deserializeBinaryFromReader);
      msg.setLastTimeSlot(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetLastTimeSlotOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetLastTimeSlotOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastTimeSlot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.LastTimeSlotResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional LastTimeSlotResponse last_time_slot = 1;
 * @return {?proto.fleet.LastTimeSlotResponse}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.getLastTimeSlot = function() {
  return /** @type{?proto.fleet.LastTimeSlotResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LastTimeSlotResponse, 1));
};


/** @param {?proto.fleet.LastTimeSlotResponse|undefined} value */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.setLastTimeSlot = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.GetLastTimeSlotOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.clearLastTimeSlot = function() {
  this.setLastTimeSlot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.hasLastTimeSlot = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.GetLastTimeSlotOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetLastTimeSlotOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OperatingAreaDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.OperatingAreaDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OperatingAreaDetails.displayName = 'proto.fleet.OperatingAreaDetails';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OperatingAreaDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OperatingAreaDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OperatingAreaDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreaDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    latLonCenter: (f = msg.getLatLonCenter()) && shared_pb.LatLon.toObject(includeInstance, f),
    phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    email: jspb.Message.getFieldWithDefault(msg, 6, ""),
    unactivatedUsersMessage: jspb.Message.getFieldWithDefault(msg, 7, ""),
    disabled: jspb.Message.getFieldWithDefault(msg, 8, false),
    disabledDate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    abbrevId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    vehicleId: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OperatingAreaDetails}
 */
proto.fleet.OperatingAreaDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OperatingAreaDetails;
  return proto.fleet.OperatingAreaDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OperatingAreaDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OperatingAreaDetails}
 */
proto.fleet.OperatingAreaDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    case 4:
      var value = new shared_pb.LatLon;
      reader.readMessage(value,shared_pb.LatLon.deserializeBinaryFromReader);
      msg.setLatLonCenter(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnactivatedUsersMessage(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisabledDate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbbrevId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OperatingAreaDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OperatingAreaDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OperatingAreaDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OperatingAreaDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLatLonCenter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_pb.LatLon.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUnactivatedUsersMessage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getDisabledDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAbbrevId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.OperatingAreaDetails.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.OperatingAreaDetails.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string time_zone = 3;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setTimeZone = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional LatLon lat_lon_center = 4;
 * @return {?proto.fleet.LatLon}
 */
proto.fleet.OperatingAreaDetails.prototype.getLatLonCenter = function() {
  return /** @type{?proto.fleet.LatLon} */ (
    jspb.Message.getWrapperField(this, shared_pb.LatLon, 4));
};


/** @param {?proto.fleet.LatLon|undefined} value */
proto.fleet.OperatingAreaDetails.prototype.setLatLonCenter = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.fleet.OperatingAreaDetails.prototype.clearLatLonCenter = function() {
  this.setLatLonCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.OperatingAreaDetails.prototype.hasLatLonCenter = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string phone = 5;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email = 6;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string unactivated_users_message = 7;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getUnactivatedUsersMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setUnactivatedUsersMessage = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool disabled = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.OperatingAreaDetails.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.fleet.OperatingAreaDetails.prototype.setDisabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string disabled_date = 9;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getDisabledDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setDisabledDate = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string abbrev_id = 10;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getAbbrevId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setAbbrevId = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string vehicle_id = 11;
 * @return {string}
 */
proto.fleet.OperatingAreaDetails.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.fleet.OperatingAreaDetails.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.TimeSlot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.TimeSlot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.TimeSlot.displayName = 'proto.fleet.TimeSlot';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.TimeSlot.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.TimeSlot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.TimeSlot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.TimeSlot.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hasTimeslot: jspb.Message.getFieldWithDefault(msg, 2, false),
    endTime: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.TimeSlot}
 */
proto.fleet.TimeSlot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.TimeSlot;
  return proto.fleet.TimeSlot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.TimeSlot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.TimeSlot}
 */
proto.fleet.TimeSlot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasTimeslot(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.TimeSlot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.TimeSlot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.TimeSlot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.TimeSlot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHasTimeslot();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.fleet.TimeSlot.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.TimeSlot.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool has_timeslot = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.TimeSlot.prototype.getHasTimeslot = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.fleet.TimeSlot.prototype.setHasTimeslot = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string end_time = 3;
 * @return {string}
 */
proto.fleet.TimeSlot.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.TimeSlot.prototype.setEndTime = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SiteWeatherForecast = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SiteWeatherForecast, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SiteWeatherForecast.displayName = 'proto.fleet.SiteWeatherForecast';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SiteWeatherForecast.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SiteWeatherForecast.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SiteWeatherForecast} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SiteWeatherForecast.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    temperature: +jspb.Message.getFieldWithDefault(msg, 3, 0.0),
    rain: +jspb.Message.getFieldWithDefault(msg, 4, 0.0),
    snow: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
    wind: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    iconName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    precipitationProbability: +jspb.Message.getFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SiteWeatherForecast}
 */
proto.fleet.SiteWeatherForecast.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SiteWeatherForecast;
  return proto.fleet.SiteWeatherForecast.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SiteWeatherForecast} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SiteWeatherForecast}
 */
proto.fleet.SiteWeatherForecast.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTemperature(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRain(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSnow(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWind(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconName(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPrecipitationProbability(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SiteWeatherForecast.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SiteWeatherForecast.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SiteWeatherForecast} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SiteWeatherForecast.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTemperature();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getRain();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getSnow();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getWind();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIconName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrecipitationProbability();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.fleet.SiteWeatherForecast.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.SiteWeatherForecast.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float temperature = 3;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getTemperature = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setTemperature = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float rain = 4;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getRain = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setRain = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float snow = 5;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getSnow = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setSnow = function(value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float wind = 6;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getWind = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setWind = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.fleet.SiteWeatherForecast.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.fleet.SiteWeatherForecast.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string icon_name = 8;
 * @return {string}
 */
proto.fleet.SiteWeatherForecast.prototype.getIconName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.fleet.SiteWeatherForecast.prototype.setIconName = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional float precipitation_probability = 9;
 * @return {number}
 */
proto.fleet.SiteWeatherForecast.prototype.getPrecipitationProbability = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.fleet.SiteWeatherForecast.prototype.setPrecipitationProbability = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SiteWeatherMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SiteWeatherMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SiteWeatherMap.displayName = 'proto.fleet.SiteWeatherMap';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SiteWeatherMap.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SiteWeatherMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SiteWeatherMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SiteWeatherMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    zoomLevel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pngdata: msg.getPngdata_asB64(),
    tileX: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tileY: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SiteWeatherMap}
 */
proto.fleet.SiteWeatherMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SiteWeatherMap;
  return proto.fleet.SiteWeatherMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SiteWeatherMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SiteWeatherMap}
 */
proto.fleet.SiteWeatherMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZoomLevel(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPngdata(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileX(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SiteWeatherMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SiteWeatherMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SiteWeatherMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SiteWeatherMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getZoomLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPngdata_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getTileX();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTileY();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.SiteWeatherMap.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.SiteWeatherMap.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 zoom_level = 2;
 * @return {number}
 */
proto.fleet.SiteWeatherMap.prototype.getZoomLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.SiteWeatherMap.prototype.setZoomLevel = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes pngdata = 3;
 * @return {string}
 */
proto.fleet.SiteWeatherMap.prototype.getPngdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes pngdata = 3;
 * This is a type-conversion wrapper around `getPngdata()`
 * @return {string}
 */
proto.fleet.SiteWeatherMap.prototype.getPngdata_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPngdata()));
};


/**
 * optional bytes pngdata = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPngdata()`
 * @return {!Uint8Array}
 */
proto.fleet.SiteWeatherMap.prototype.getPngdata_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPngdata()));
};


/** @param {!(string|Uint8Array)} value */
proto.fleet.SiteWeatherMap.prototype.setPngdata = function(value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional int32 tile_x = 4;
 * @return {number}
 */
proto.fleet.SiteWeatherMap.prototype.getTileX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.SiteWeatherMap.prototype.setTileX = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 tile_y = 5;
 * @return {number}
 */
proto.fleet.SiteWeatherMap.prototype.getTileY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.SiteWeatherMap.prototype.setTileY = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.fleet.ScheduleType = {
  UNKNOWN_SCHEDULE: 0,
  REGULAR_SCHEDULE: 1,
  ALTERNATE_SCHEDULE: 2,
  CANCELLATION: 3,
  NO_SCHEDULE: 4
};

goog.object.extend(exports, proto.fleet);
